import { withRouter } from "react-router-dom";
import compose from "recompose/compose";
import withHandlers from "recompose/withHandlers";
import get from "lodash/get";
import AccordionItem from "./AccordionItem";
import withState from "recompose/withState";

const enhance = compose(
  withRouter,
  withState("active", "setActive", (props) => get(props, "isExpanded", false)),
  withHandlers({
    handleOnClick: (props) => () => {
      const isActive = props.active;
      const action = !isActive ? "Open" : "Close";

      if (props.trackToggleEvent) {
        props.trackToggleEvent(action);
      }

      props.setActive(!isActive);
    },
  })
);

export default enhance(AccordionItem);
